import { ArrowUpRight, Award } from 'lucide-react';

export function ProjectAwards({ awards, compact = false }) {
  return <div className={'project-awards' + (compact ? ' is-compact' : '')}>
    <Award size={compact ? 20 : 28} strokeWidth={1.5} aria-hidden="true" />
    <div><p>{awards.event} <span>企業賞受賞</span></p><ul>{awards.names.map(name => <li key={name}>{name}</li>)}</ul></div>
    {!compact && awards.photos && <div className="experience-photos award-photos">{awards.photos.map(photo => <figure key={photo.src}><img src={photo.src} width={photo.width} height={photo.height} alt={photo.alt} loading="lazy" decoding="async" /><figcaption>{photo.caption}</figcaption></figure>)}</div>}
  </div>;
}

export function ProductScreenshot({ image }) {
  return <figure className="product-screenshot">
    <a href={image.src} target="_blank" rel="noreferrer" aria-label={image.alt + ' 別タブで拡大'}>
      <img src={image.src} alt={image.alt} width={image.width} height={image.height} loading="lazy" />
      <span className="screenshot-expand">拡大する <ArrowUpRight size={14} aria-hidden="true" /></span>
    </a>
    <figcaption>{image.caption}</figcaption>
  </figure>;
}

export default function ProjectDetails({ project }) {
  const { caseStudy, images } = project;
  return <>
    <p className="eyebrow">CASE STUDY / {project.category} / {project.year}</p>
    <h2 id="dialog-title">{project.title}</h2>
    <p className="case-study-headline">{caseStudy.headline}</p>
    <p className="dialog-intro">{project.overview}</p>
    <ProjectAwards awards={project.awards} />
    <dl className="case-study-facts">{caseStudy.facts.map(fact => <div key={fact.label}><dt>{fact.label}</dt><dd>{fact.value}</dd></div>)}</dl>
    <div className="case-study-links"><div className="project-tags">{project.tags.map(tag => <span key={tag}>{tag}</span>)}</div><a href={project.url} target="_blank" rel="noreferrer" className="button button-dark">アプリを使ってみる <ArrowUpRight size={18} /></a></div>
    <ProductScreenshot image={images[0]} />
    {caseStudy.sections.map((section, index) => <div key={section.label}>
      <section className="case-study-section"><p className="eyebrow">{section.label}</p><h3>{section.title}</h3>{section.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}</section>
      {index === 1 && <ProductScreenshot image={images[1]} />}
    </div>)}
    <div className="case-study-closing"><p>教職で培った視点を、<br />学習サービスの設計と改善に。</p><a href={project.url} target="_blank" rel="noreferrer" className="button button-dark">アプリを使ってみる <ArrowUpRight size={18} /></a></div>
  </>;
}
